import { BaseVm } from '@/mobxTools'
import { VipExpiredTipsPanelProps } from '.'

export class VipExpiredTipsPanelVm extends BaseVm<VipExpiredTipsPanelProps> {
  props!: VipExpiredTipsPanelProps

  public async onViewCreate() {}
}
